import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import NavBar from "../Utils/NavBar";
import FootBar from "../Utils/FootBar";
import BackDecoration from "../Utils/BackDecoration";
import DoneMessages from "../Utils/DoneMessage";
import uniqid from "uniqid";
require("../../assets/stylesheets/Inscribe/Inscribe.css");

function AutoComplete() {
  const [dataMatter, setDataMatter] = useState([]);

  useEffect(() => {
    axios
      .get(
        "https://ferias-ingenio-backend.vercel.app/api/categories/getcategories"
      )
      .then((res) => {
        setDataMatter(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const MatterRow = Object.values(dataMatter).map((matter) => {
    return matter.matters.map((e) => {
      return <option value={e}>{e}</option>;
    });
  });

  const MasterRow = Object.values(dataMatter).map((master) => {
    return master.masters.map((e) => {
      return <option value={e}>{e}</option>;
    });
  });

  return (
    <div>
      <datalist id="matters">{MatterRow}</datalist>
      <datalist id="masters">{MasterRow}</datalist>
    </div>
  );
}

function FormInscribe() {
  const [content, setContent] = useState({
    title: "",
    coordinator: "",
    url: "",
    team: "",
    description: "",
    matter: "",
    master: "",
    payregister: "",
  });

  const [text, setText] = useState("");
  const [code, setCode] = useState(200);
  const [messageView, setMessageView] = useState(false);

  useEffect(() => {}, [messageView]);

  const handleSubmit = (e) => {
    setMessageView(false);
    e.preventDefault();

    const newProject = {
      id: uniqid(),
      title: content.title,
      coordinator: content.coordinator,
      url: content.url,
      team: content.team,
      description: content.description,
      matter: content.matter,
      master: content.master,
      payregister: content.payregister,
    };
    axios
      .post(
        "https://ferias-ingenio-backend.vercel.app/api/projects/addproject",
        newProject
      )
      .then((res) => {
        setText(res.data.message);
        setCode(res.data.code);
        setMessageView(true);

        if (res.data.code == 200) {
          setContent({
            title: "",
            coordinator: "",
            url: "",
            team: "",
            description: "",
            matter: "",
            master: "",
            payregister: "",
          });
        }
      })
      .then((err) => {});
  };

  const urlVerify = (url) => {
    if (url.length > 28) {
      return true;
    } else {
      return false;
    }
  };

  const validate = (text) => {
    if (
      text.includes("[") ||
      text.includes("]") ||
      text.includes("{") ||
      text.includes("}") ||
      text.includes('"') ||
      text.includes("|") ||
      text.includes("&") ||
      text.includes("`") ||
      text.includes("*") ||
      text.includes("+") ||
      text.includes(";")
    ) {
      return "inputError";
    } else {
      return "input";
    }
  };

  const handleDesibled = () => {
    if (
      validate(content.title) == "input" &&
      validate(content.coordinator) == "input" &&
      validate(content.url) == "input" &&
      !urlVerify(content.url) &&
      validate(content.team) == "input" &&
      validate(content.description) == "input" &&
      validate(content.matter) == "input" &&
      validate(content.master) == "input" &&
      validate(content.payregister) == "input"
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className="form">
      {messageView && (
        <DoneMessages text={text} code={code} visibility={messageView} />
      )}
      <div className="formHeader">Inscribe tu proyecto</div>
      ¿No sabes cómo inscribirte? Mira un <a href="/tutorials">Tutorial</a>
      <form className="formInputs" onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="text"
            className={`large ${validate(content.title)}`}
            value={content.title}
            onChange={(e) => {
              setContent({ ...content, title: e.target.value });
              handleDesibled();
            }}
            required
            name="title"
          />
          {validate(content.title) == "inputError" && (
            <p className="onError">No se permiten caracteres especiales</p>
          )}
          <label htmlFor="title" className="input-label">
            Título
          </label>
        </div>
        <div className="input-group">
          <input
            type="text"
            className={`large ${validate(content.coordinator)}`}
            value={content.coordinator}
            onChange={(e) => {
              setContent({ ...content, coordinator: e.target.value });
              handleDesibled();
            }}
            required
            name="coordinator"
          />
          {validate(content.coordinator) == "inputError" && (
            <p className="onError">No se permiten caracteres especiales</p>
          )}
          <label htmlFor="coordinator" className="input-label">
            Coordinador
          </label>
        </div>
        <div className="input-group">
          <input
            type="url"
            className={`large ${validate(content.url)}`}
            value={content.url}
            onChange={(e) => {
              setContent({ ...content, url: e.target.value });
              handleDesibled();
            }}
            required
            name="URL"
          />
          {validate(content.url) == "inputError" && (
            <p className="onError">
              Ingresa la url compartida de tu proyecto en youtube
            </p>
          )}
          {urlVerify(content.url) && (
            <p className="onError">
              URL incorrecta, asegurate de seguir las{" "}
              <a href="./tutorials">instrucciones </a>{" "}
            </p>
          )}
          <label htmlFor="URL" className="input-label">
            URL
          </label>
        </div>
        <div className="input-group">
          <textarea
            className={`area ${validate(content.team)}`}
            value={content.team}
            onChange={(e) => {
              setContent({ ...content, team: e.target.value });
              handleDesibled();
            }}
            required
            name="team"
          />
          {validate(content.team) == "inputError" && (
            <p className="onError">No se permiten caracteres especiales</p>
          )}
          <label htmlFor="team" className="input-label">
            Integrantes del equipo
          </label>
        </div>
        <div className="input-group">
          <textarea
            className={`area ${validate(content.description)}`}
            value={content.description}
            onChange={(e) => {
              setContent({ ...content, description: e.target.value });
              handleDesibled();
            }}
            required
            name="description"
          />
          {validate(content.description) == "inputError" && (
            <p className="onError">No se permiten caracteres especiales</p>
          )}
          <label htmlFor="description" className="input-label">
          Descripción del proyecto
          </label>
        </div>
        <input
          className={`large ${validate(content.matter)}`}
          type="text"
          placeholder="Tu clase"
          list="matters"
          value={content.matter}
          onChange={(e) => {
            setContent({ ...content, matter: e.target.value });
            handleDesibled();
          }}
          autoComplete="off"
        />
        {validate(content.matter) == "inputError" && (
          <p className="onError">No se permiten caracteres especiales</p>
        )}
        <AutoComplete id="mattersList" display="none" />

        <input
          placeholder="Catedrático(a)"
          type="text"
          className={`large ${validate(content.master)}`}
          value={content.master}
          list="masters"
          autoComplete="off"
          onChange={(e) => {
            setContent({ ...content, master: e.target.value });
            handleDesibled();
          }}
          required
        />
        {validate(content.master) == "inputError" && (
          <p className="onError">No se permiten caracteres especiales</p>
        )}
        <input
          placeholder="No. recibo de pago (Si no pagaste escribe 0)"
          type="text"
          className={`large ${validate(content.payregister)}`}
          value={content.payregister}
          onChange={(e) => {
            setContent({ ...content, payregister: e.target.value });
            handleDesibled();
          }}
          required
        />
        {validate(content.payregister) == "inputError" && (
          <p className="onError">No se permiten caracteres especiales</p>
        )}
        <button
          type="submit"
          className="small-btnForm"
          disabled={handleDesibled()}
        >
          Inscribirme
        </button>
      </form>
    </div>
  );
}

function Inscribe() {
  return (
    <div className="Inscribe">
      <NavBar />
      <BackDecoration />
      <FormInscribe />
    </div>
  );
}

export default Inscribe;
